import TitleAnimation from "./animations/TitleAnimation";
import ParagraphAnimation from "./animations/ParagraphAnimation";
import ScrollSpy from "./utils/scrollSpy";
import Slideshow from "./utils/slideshow";

(() => {
  const onReady = () => {
    const titles = document.querySelectorAll('[data-animate="title"]');

    titles.forEach((el) => {
      new TitleAnimation({ el });
    });

    const paragraphs = document.querySelectorAll('[data-animate="paragraph"]');

    paragraphs.forEach((el) => {
      new ParagraphAnimation({ el });
    });

    // Initialize ScrollSpy to update URL when scrolling to sections
    const scrollSpy = ScrollSpy();
    scrollSpy.init('section[id], div[id]');

    // Initialize slideshow functionality
    const slideshow = Slideshow();

    slideshow.init();

    // Make slideshow instance globally accessible for lightbox control
    window.slideshowInstance = slideshow;

    // Set current year in footer
    const currentYearElement = document.getElementById('current-year');
    if (currentYearElement) {
      currentYearElement.textContent = new Date().getFullYear();
    }
  };

  if (document.readyState !== "loading") {
    onReady();
  } else {
    document.addEventListener("DOMContentLoaded", onReady);
  }
})();
